<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`固定费用支出表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :loading="loading" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :btns="btns" :getTotal="getTotal" :showTotal="true" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :labelWidth="'150px'" :form="mform" :formCtrl="mformCtrl"
      @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceFixedFeeList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'fixedpay',
      breadcrumb: [
        { name: "财务管理" },
        { name: "固定费用支出表" },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.month
        },
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "状态",
          keyName: "cartype",
          type: "select",
          options: [],
        },
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
      ],
      cols: [
        // { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "vtype", label: "车队加油" },
        { prop: "vtype", label: "月份" },
        { prop: "vtype", label: "合计" },
      ],
      getTotalProperty: ['money'],
      baseParams: ['month'],
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            this.setModalData(data)
            this.showDialog()
          },
        },
      ],
      getOptionUrl: 'index',
      title: '支出金额填写',
      mform: {},
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
          viewMode: true,
        },
      ],
    };
  },
  methods: {
    setOptions({ fleet, cartype, fixedauth }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fleet') {
          v.options = fleet.map(c => {
            return {
              label: c.nickname,
              value: c.id,
            }
          })
        } else if (v.keyName === 'cartype') {
          v.options = cartype.map(c => {
            return {
              label: c.name,
              value: c.name,
            }
          })
        }
      })
      const arr = []
      fixedauth.map((v) => {
        const o = {
          prop: v.enname,
          label: v.authname,
          align: 'right',
          className: 'pr30',
        }
        if (v.authname.length >= 5 && v.authname.length < 8) {
          o.width = 150
        } else if (v.authname.length >= 8) {
          o.width = 200
        } else {
          o.width = 120
        }
        arr.push(o)
        this.mformCtrl.push({
          label: v.authname,
          keyName: v.enname,
          err: `请填写${v.authname}`,
          type: "text",
          unit: '元',

        })
      })
      this.cols = [
        { prop: "month", label: "月份" },
        { prop: "license", label: "车牌号", width: 100 },
        ...arr,
        { prop: "foil", label: "车队加油" },
        // { prop: "ecort", label: "打短押运工资", align: 'right', className: 'pr30', width: 140 },
        { prop: "total", label: "合计", align: 'right', className: 'pr30', width: 100 },
      ]
      this.getTotalProperty = [
        ...arr.map(v => v.prop), 'foil', 'ecort', 'total'
      ]
      this.doLayout()
      this.$forceUpdate()
    },
    setModalData(data) {
      this.mformCtrl.map(v => {
        const key = v.keyName
        this.mform[key] = data[key]
      })
      this.mform.id = data.id
      // this.mform.orderid = data.orderid
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      let url = `${this.baseUrl}/addedu`
      const params = {
        userid: this.user.id,
        ...this.mform,
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'fixed_expense',
      }

      console.log(url, params)

      // this.loading = true

      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getOptions()
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .dialog {
    .el-dialog {
      width: 560px;

      .modal-scroll {
        height: 500px;

        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .is-horizontal {
          display: none;
        }
      }
    }

    .el-form {
      .el-input {
        width: 230px;
      }
    }

    .btns {
      margin: 0;
      text-align: center;
    }
  }
}

/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>
